import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SubscriptionContainer } from 'app/modules/common/helpers/SubscriptionsContainer';
import { SharedService } from 'app/modules/common/services/shared-service';
import { IDropDown } from 'app/modules/fuse/intefaces/IDropDown';
import { SendingService } from 'app/modules/fuse/services/sending.service';
@Component({
    selector: 'app-reports-popup',
    templateUrl: './reports-popup.component.html',
    styleUrls: ['./reports-popup.component.scss'],
    standalone: false
})

export class ReportsPopupComponent implements OnInit {

  private subs: SubscriptionContainer;
  public reportForm: UntypedFormGroup;
  public admintrativeUsers = [];  
  public SelectedAdministrativeUser: any;
  public reportTypes: IDropDown[] =
    [
      { value: 'personal-0', viewValue: 'Personal' },
      { value: 'sme-1', viewValue: 'SME' },
      { value: 'jefe-de-area-2', viewValue: 'Jefe de Area' }
    ];
  public selectedReport: any;

  constructor(
    private dialogRef: MatDialogRef<ReportsPopupComponent>,
    private _sharedService: SharedService,
    private _sendingService: SendingService,
    private _fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) private users
  ) {
    this.admintrativeUsers = users.admintrativeUsers
  }

  ngOnInit(): void {
    this._sendingService.selectedCompanyId = localStorage.getItem('Empresa');
    this.createReportsForm();
  }

  createReportsForm() {
    this.reportForm = this._fb.group({
      Listado: ["personal-0"],
      SelectedAdministrativeUser: [''],
      SelectedCompanyId: [this._sendingService.selectedCompanyId]
    });
  }

  onReportChange(event) {
    this.reportForm.get('listado').setValue(event.value);
  }

  public onAdminUserChange(event: any) {
    this.SelectedAdministrativeUser = event.value;
}

  onSubmit(): void {
    this.reportForm.markAllAsTouched();
    if (this.reportForm.valid) {
      this._sendingService.Listados(this.reportForm.value).subscribe(res => {
        if (res.result != null && res.code === 0) {
          this._sharedService.ShowSnackBar(res.result);
        } else {
          this._sharedService.ShowSnackBar('lo siento, el proceso falló');
        }
      }, error => {
        this._sharedService.ShowSnackBar('API Se produjo un error');
        console.error(error);
      });
      this.close();
    }
  }

  public close(): void {
    this.dialogRef.close();
  }

}
